<mat-card appearance="raised" class="setphone-form--container mat-elevation-z12">
  <div class="setphone-form--header">
    @if (!(showNumberField | async)) {
      <h5 class="setphone-form--title">{{ sysText[page + '_phoneForm_title'] }}</h5>
      <p class="body2 setphone-form--subtitle">{{ sysText[page + '_phoneForm_subtitle'] }}</p>
    } @else {
      <h5 class="setphone-form--title">{{ sysText[page + '_phoneForm_titleSetNumber'] }}</h5>
      <p class="body2 setphone-form--subtitle">{{ sysText[page + '_phoneForm_subtitleSetNumber'] }}</p>
    }
  </div>
  <mat-card-content>
    <form
      [formGroup]="phoneForm"
      (ngSubmit)="!isSubmitting && onSubmit()"
      class="setphone-form--form">
      @if (!(showNumberField | async)) {
        <mat-form-field color="accent">
          <mat-label>{{ sysText[page + '_phoneForm_code'] }}</mat-label>
          <input
            #otpInput
            type="number"
            matInput
            formControlName="otp"
            autocomplete="off"/>
            <mat-error>{{ otp.errors?.msError }}</mat-error>
          </mat-form-field>
        }
        @if ((showNumberField | async)) {
          <mat-form-field color="accent">
            <mat-label>{{ sysText[page + '_accountForm_phonenumber'] }}</mat-label>
            <input
              #phoneInput
              type="number"
              matInput
              formControlName="phonenumber"
              autocomplete="tel"/>
              <mat-error>{{ phonenumber.errors?.msError }}</mat-error>
            </mat-form-field>
          }
          <!-- the buttons keep focus while submitting: showProgress lays the spinner over the label, disabledInteractive keeps them focusable, and (ngSubmit) and the click are guarded -->
          @if (!(showNumberField | async)) {
            <button
              type="submit"
              mat-flat-button
              color="accent"
              class="button setphone-form--button"
              [disabled]="isSubmitting"
              disabledInteractive
              [showProgress]="isSubmitting"
              [attr.aria-label]="isSubmitting ? sysText.submitting_ariaLabel : null">
              {{ sysText[page + '_phoneForm_button'] }}
              <mat-spinner progressIndicator diameter="30" color="accent"></mat-spinner>
            </button>
          }
          @if ((showNumberField | async)) {
            <button
              type="button"
              mat-flat-button
              color="accent"
              class="button setphone-form--button"
              [disabled]="isSubmitting"
              disabledInteractive
              [showProgress]="isSubmitting"
              [attr.aria-label]="isSubmitting ? sysText.submitting_ariaLabel : null"
              (click)="!isSubmitting && onSetNumber()">
              {{ sysText[page + '_phoneForm_buttonSetNumber'] }}
              <mat-spinner progressIndicator diameter="30" color="accent"></mat-spinner>
            </button>
          }
        </form>
        <div class="setphone-form--link caption">
          @if (!(showNumberField | async)) {
            <button type="button" class="button-reset" (click)="onResend()">
              {{ sysText[page + '_phoneForm_resend'] }}
            </button>
          }
          @if (!(showNumberField | async)) {
            <button type="button" (click)="onShowSetPhoneNumber()" class="button-reset setphone-form--link__secondary">
              {{ sysText[page + '_phoneForm_setDifferent'] }}
            </button>
          }
          @if ((showNumberField | async)) {
            <button type="button" (click)="onHideSetPhoneNumber()" class="button-reset setphone-form--link__secondary">
              {{ sysText[page + '_phoneForm_goBackSetNumber'] }}
            </button>
          }
          @if (!(showNumberField | async)) {
            <button type="button" (click)="onGoBack()" class="button-reset setphone-form--link__secondary">
              {{ sysText[page + '_phoneForm_goBack'] }}
            </button>
          }
        </div>
      </mat-card-content>
    </mat-card>

